<template>
   <b-modal
    ref="modal"
    title="Điều chỉnh hoá đơn điện tử"
    header-bg-variant="info"
    header-text-variant="white"
    @ok="handleSubmit"
    ok-title="Xác nhận điều chỉnh"
    ok-variant="info"
    cancel-title="Đóng"
    :ok-disabled="isSubmitting"
    no-close-on-backdrop
    size="lg"
    > <template v-if="invoice"
      > <!-- Original invoice info -->
      <div class="bg-light p-3 rounded mb-4">

        <h6 class="font-weight-bold mb-2">
           <i class="fas fa-file-invoice mr-1"></i> Hoá đơn gốc
        </h6>
         <b-row
          > <b-col md="4"
            > <small class="text-muted">Số hoá đơn</small>
            <div class="font-weight-bold">{{ invoice.invoiceNo || '---' }}</div>
             </b-col
          > <b-col md="4"
            > <small class="text-muted">Ngày hoá đơn</small>
            <div>{{ formatInvoiceDateShort(invoice.invoiceDate) }}</div>
             </b-col
          > <b-col md="4"
            > <small class="text-muted">Tổng tiền</small>
            <div class="font-weight-bold"> {{ formatCurrency(invoice.totalAmount) }} </div>
             </b-col
          > </b-row
        >
      </div>
       <!-- Adjustment type --> <b-form-group
        label="Loại điều chỉnh *"
        label-class="font-weight-bold"
        > <b-form-radio-group
          v-model="form.adjustmentType"
          :options="adjustmentTypeOptions"
          stacked
        ></b-form-radio-group
        > </b-form-group
      > <!-- Adjustment reason --> <b-form-group
        label="Lý do điều chỉnh *"
        label-class="font-weight-bold"
        :invalid-feedback="reasonError"
        :state="reasonState"
        > <b-form-textarea
          v-model="form.reason"
          rows="2"
          placeholder="Nhập lý do điều chỉnh..."
          :state="reasonState"
          @input="$v.form.reason.$touch()"
        ></b-form-textarea
        > </b-form-group
      > <!-- Amount adjustment (for type 1 or 2) --> <template
        v-if="form.adjustmentType === 1 || form.adjustmentType === 2"
        >
        <div class="mb-3">
           <label class="font-weight-bold">Chi tiết điều chỉnh *</label> <b-table
            bordered
            hover
            small
            :items="form.items"
            :fields="itemFields"
            class="mb-2 table-responsive"
            > <template #cell(itemName)="{ item, index }"
              > <b-form-input
                v-model="form.items[index].itemName"
                size="sm"
                required
              ></b-form-input
              > </template
            > <template #cell(unitOfMeasure)="{ item, index }"
              > <b-form-input
                v-model="form.items[index].unitOfMeasure"
                size="sm"
              ></b-form-input
              > </template
            > <template #cell(quantity)="{ item, index }"
              > <b-form-input
                type="number"
                v-model.number="form.items[index].quantity"
                size="sm"
                min="0"
                step="any"
                @input="updateItemAmount(index)"
              ></b-form-input
              > </template
            > <template #cell(unitPrice)="{ item, index }"
              > <b-form-input
                type="number"
                v-model.number="form.items[index].unitPrice"
                size="sm"
                min="0"
                @input="updateItemAmount(index)"
              ></b-form-input
              > </template
            > <template #cell(amount)="{ item, index }"
              > <b-form-input
                type="number"
                v-model.number="form.items[index].amount"
                size="sm"
                min="0"
              ></b-form-input
              > </template
            > <template #cell(taxRate)="{ item, index }"
              > <b-form-select
                v-model.number="form.items[index].taxRate"
                :options="taxRateOptions"
                size="sm"
                @change="updateItemAmount(index)"
              ></b-form-select
              > </template
            > <template #cell(taxAmount)="{ item, index }"
              > <b-form-input
                type="number"
                v-model.number="form.items[index].taxAmount"
                size="sm"
                min="0"
              ></b-form-input
              > </template
            > <template #cell(actions)="{ index }"
              > <b-button
                size="sm"
                variant="danger"
                class="btn-icon"
                @click="removeItem(index)"
                :disabled="form.items.length === 1"
                > <i class="fas fa-trash"></i> </b-button
              > </template
            > </b-table
          > <b-button
            size="sm"
            variant="outline-primary"
            @click="addItem"
            > <i class="fas fa-plus mr-1"></i> Thêm dòng </b-button
          >
        </div>

        <div class="d-flex justify-content-end align-items-center bg-light p-2 rounded">
           <span class="mr-3 font-weight-bold">Tổng tiền điều chỉnh: </span> <span
            class="text-primary font-weight-bold"
            style="font-size: 1.1rem"
            >{{ formatCurrency(totalAdjustAmount) }}</span
          >
        </div>

        <div
          v-if="submitAttempted && !hasValidItems"
          class="text-danger small mt-1 text-right"
        >
           Vui lòng nhập đầy đủ thông tin cho ít nhất 1 dòng điều chỉnh (Tên hàng hoá và Thành tiền
          phải lớn hơn 0)
        </div>
         </template
      > <!-- Info adjustment (type 3) --> <template v-if="form.adjustmentType === 3"
        > <b-row
          > <b-col md="6"
            > <b-form-group
              label="Tên khách hàng (mới)"
              label-class="font-weight-bold"
              > <b-form-input
                v-model="form.newBuyerName"
                size="sm"
                placeholder="Để trống nếu không đổi"
              ></b-form-input
              > </b-form-group
            > </b-col
          > <b-col md="6"
            > <b-form-group
              label="MST khách (mới)"
              label-class="font-weight-bold"
              > <b-form-input
                v-model="form.newBuyerTaxCode"
                size="sm"
                placeholder="Để trống nếu không đổi"
              ></b-form-input
              > </b-form-group
            > </b-col
          > <b-col md="12"
            > <b-form-group
              label="Địa chỉ (mới)"
              label-class="font-weight-bold"
              > <b-form-input
                v-model="form.newBuyerAddress"
                size="sm"
                placeholder="Để trống nếu không đổi"
              ></b-form-input
              > </b-form-group
            > </b-col
          > </b-row
        > </template
      > </template
    > <!-- Loading --> <loading-overlay
      :active="isSubmitting"
      :is-full-page="false"
      > <template #default
        >
        <div class="text-center">
           <b-spinner variant="info"></b-spinner>
          <p class="mt-2 text-muted">Đang xử lý điều chỉnh...</p>

        </div>
         </template
      > </loading-overlay
    > </b-modal
  >
</template>

<script>
  import { validationMixin } from 'vuelidate'
  import { required, minLength } from 'vuelidate/lib/validators'
  import LoadingOverlay from '@/view/components/common/LoadingOverlay.vue'
  import { EINVOICE_ADJUST } from '@/core/services/store/modules/einvoice/einvoice.module'
  import { EINVOICE_ADJUSTMENT_TYPE } from '@/utils/einvoice.enum'
  import { getToastInstance } from '@/utils/toastHelper'
  import einvoiceMixin from '../mixins/einvoice.mixin'

  const { makeToastSuccess, makeToastFailure } = getToastInstance()

  export default {
    name: 'EInvoiceAdjustModal',
    components: { LoadingOverlay },
    mixins: [validationMixin, einvoiceMixin],
    props: {
      invoice: {
        type: Object,
        default: null,
      },
    },
    data() {
      return {
        isSubmitting: false,
        submitAttempted: false,
        form: {
          adjustmentType: EINVOICE_ADJUSTMENT_TYPE.INCREASE,
          reason: '',
          adjustAmount: null,
          newBuyerName: '',
          newBuyerTaxCode: '',
          newBuyerAddress: '',
          items: [],
        },
        itemFields: [
          { key: 'itemName', label: 'Tên HH/DV' },
          { key: 'unitOfMeasure', label: 'ĐVT', class: 'text-center' },
          { key: 'quantity', label: 'Số lượng', class: 'text-right' },
          { key: 'unitPrice', label: 'Đơn giá', class: 'text-right' },
          { key: 'amount', label: 'Thành tiền', class: 'text-right' },
          { key: 'taxRate', label: '% VAT', class: 'text-right' },
          { key: 'taxAmount', label: 'Tiền thuế', class: 'text-right' },
          { key: 'actions', label: '', class: 'text-center' },
        ],
        taxRateOptions: [
          { value: -1, text: 'KCT' },
          { value: 0, text: '0%' },
          { value: 5, text: '5%' },
          { value: 8, text: '8%' },
          { value: 10, text: '10%' },
        ],
      }
    },
    validations: {
      form: {
        reason: { required, minLength: minLength(5) },
      },
    },
    computed: {
      adjustmentTypeOptions() {
        return [
          { value: EINVOICE_ADJUSTMENT_TYPE.INCREASE, text: 'Điều chỉnh tăng' },
          { value: EINVOICE_ADJUSTMENT_TYPE.DECREASE, text: 'Điều chỉnh giảm' },
          {
            value: EINVOICE_ADJUSTMENT_TYPE.INFO_ONLY,
            text: 'Điều chỉnh thông tin (không thay đổi số tiền)',
          },
        ]
      },
      reasonState() {
        const { $dirty, $error } = this.$v.form.reason
        return $dirty ? !$error : null
      },
      reasonError() {
        if (!this.$v.form.reason.required) return 'Vui lòng nhập lý do điều chỉnh'
        if (!this.$v.form.reason.minLength) return 'Lý do phải có ít nhất 5 ký tự'
        return ''
      },
      hasValidItems() {
        if (this.form.adjustmentType === 3) return true
        if (!this.form.items || this.form.items.length === 0) return false
        return this.form.items.some((item) => item.itemName && item.amount > 0)
      },
      totalAdjustAmount() {
        if (!this.form.items || this.form.items.length === 0) return 0
        return this.form.items.reduce(
          (sum, item) => sum + (Number(item.amount) || 0) + (Number(item.taxAmount) || 0),
          0,
        )
      },
    },
    methods: {
      addItem() {
        this.form.items.push({
          lineNumber: this.form.items.length + 1,
          itemCode: '',
          itemName: '',
          unitOfMeasure: '',
          quantity: null,
          unitPrice: null,
          amount: null,
          taxRate: 10,
          taxAmount: null,
        })
      },
      removeItem(index) {
        this.form.items.splice(index, 1)
        // Re-index line numbers
        this.form.items.forEach((item, idx) => {
          item.lineNumber = idx + 1
        })
      },
      updateItemAmount(index) {
        const item = this.form.items[index]
        if (item.quantity && item.unitPrice) {
          item.amount = Number(item.quantity) * Number(item.unitPrice)
        }

        if (item.amount && item.taxRate >= 0) {
          item.taxAmount = Math.round(Number(item.amount) * (Number(item.taxRate) / 100))
        } else if (item.taxRate < 0) {
          item.taxAmount = 0
        }
      },
      show() {
        this.resetForm()
        this.$refs.modal.show()
      },
      hide() {
        this.$refs.modal.hide()
      },
      resetForm() {
        this.submitAttempted = false
        this.form = {
          adjustmentType: EINVOICE_ADJUSTMENT_TYPE.INCREASE,
          reason: '',
          adjustAmount: null,
          newBuyerName: '',
          newBuyerTaxCode: '',
          newBuyerAddress: '',
          items: [],
        }
        this.addItem() // add a default empty row
        this.$v.$reset()
      },
      async handleSubmit(bvModalEvt) {
        bvModalEvt.preventDefault()
        this.submitAttempted = true
        this.$v.form.$touch()
        if (this.$v.form.$invalid) return
        if (!this.hasValidItems) return

        this.isSubmitting = true
        try {
          const overrides = {}
          const isInfoOnly = this.form.adjustmentType === 3

          if (isInfoOnly) {
            if (this.form.newBuyerName) overrides.buyerName = this.form.newBuyerName
            if (this.form.newBuyerTaxCode) overrides.buyerTaxCode = this.form.newBuyerTaxCode
            if (this.form.newBuyerAddress) overrides.buyerAddress = this.form.newBuyerAddress
          }

          // Clean up items for types 1 and 2
          let submitItems = []
          if (!isInfoOnly) {
            // Filter out completely empty items but keep valid ones
            submitItems = this.form.items
              .filter((item) => item.itemName && item.amount > 0)
              .map((item) => ({
                lineNumber: item.lineNumber,
                itemCode: item.itemCode || '',
                itemName: item.itemName,
                unitOfMeasure: item.unitOfMeasure || '',
                quantity: Number(item.quantity) || 0,
                unitPrice: Number(item.unitPrice) || 0,
                amount: Number(item.amount) || 0,
                taxRate: Number(item.taxRate),
                taxAmount: Number(item.taxAmount) || 0,
              }))
          }

          const requestPayload = {
            salesInvoiceId: this.invoice.salesInvoiceId,
            saleType: this.invoice.saleType,
            adjustmentType: this.form.adjustmentType,
            reason: this.form.reason,
            ...overrides,
          }

          if (!isInfoOnly) {
            requestPayload.items = submitItems
          }

          await this.$store.dispatch(EINVOICE_ADJUST, requestPayload)

          makeToastSuccess('Điều chỉnh hoá đơn thành công')
          this.$emit('adjusted')
          this.hide()
        } catch (err) {
          const msg = err?.message || 'Điều chỉnh thất bại'
          makeToastFailure(msg)
        } finally {
          this.isSubmitting = false
        }
      },
    },
  }
</script>

